// get the page URL - Strip:
//   - ?query=parameters
//   - #hasTag
//   - Trailing slash
export const getRawUrlWithoutParameters = () => {
    let url = window.location.href;

    url = url.replace(window.location.search, '');

    if (url.indexOf('#') !== -1) {
        url = url.substring(0, url.indexOf('#'));
    }

    if (url.endsWith('/')) {
        url = url.substring(0, url.length - 1);
    }

    return url;
};
